/* eslint-disable import/no-anonymous-default-export */
export default (request = [], action) => {
  switch (action.type) {
    case "GET_ALL_REQUEST":
      return action.payload;
    case "CREATE_REQUEST":
      return [...request, action.payload];
    case "DELETE_REQUEST":
      return request.filter((data) => data._id !== action.payload);
    default:
      return request;
  }
};
